import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/index-template.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Witamy na stronach grupy Facebook `}<a parentName="p" {...{
        "href": "https://www.facebook.com/groups/homeassistantpolska"
      }}>{`Home Assistant Polska`}</a>{`.`}</p>
    <p>{`Znajdziesz tu informacje na temat budowania instalacji inteligentnego domu w oparciu o Home Assistant.`}</p>
    <p>{`Materiały tu umieszczone mają na celu zebranie podstawowych informacji dla zainteresowanych tą tematyką.`}</p>
    <p>{`Są tutaj także odpowiedzi na pytania wielokrotnie zadawane na grupie.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      